export default __webpack_public_path__ + "static/buderus-starclub-73c6c32cf252fcad064a0148abda2cc8.jpg";